module.exports = [{
      plugin: require('/Users/oddgeir/Development/Sourcecode/kobenhavn.knowit.no/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/oddgeir/Development/Sourcecode/kobenhavn.knowit.no/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
